// extracted by mini-css-extract-plugin
export default {"imageSample":"GallerySelectPage_imageSample__nvqwl"};